import { texteAvecNoms } from '@taki/data-model';

/**
 * UN MESSAGE RESUME EN TEXTE PAR LA FENETRE (titre d'un fil, notification
 * affichee) : ses mentions en NOMS, jamais en jetons `@[id]` (passe 2 du
 * controleur, ecart J). `texteAvecNoms` est celui du socle ; les noms
 * viennent de l'annuaire deja charge pour les mentions (`EntreeDeMention`).
 */
export function resumeAvecNoms(texte: string, entrees: readonly { id: string; genre: string; libelle: string }[]): string {
  const noms = new Map(entrees.filter((entree) => entree.genre === 'personne').map((entree) => [entree.id, entree.libelle]));
  return texteAvecNoms(texte, (personId) => noms.get(personId));
}
